module.exports = __webpack_public_path__ + "img/text_voting-match.bd559d37.png";